import { useAnalytics } from '@/app/utils/useAnalytics';
import SurgeryOnboarding from '@/modules/LandingHeaderV2/assets/SurgeryOnboarding.svg';
import Link from 'next/link';

import Button from '@material-ui/core/Button';

import styles from './LoggedOutActionButtons.module.scss';

interface LoggedOutActionButtonsProps {
  onSignInClick?: () => void;
  onRegisterClick?: () => void;
  signInUrl: string;
  registerUrl: string;
  isSmallScreen?: boolean;
}

export const LoggedOutActionButtons = ({
  onSignInClick,
  onRegisterClick,
  signInUrl,
  registerUrl,
  isSmallScreen,
}: LoggedOutActionButtonsProps) => {
  const track = useAnalytics();

  return (
    <div className={styles.actionButtonsContainer}>
      {!isSmallScreen && (
        <Link href={signInUrl} onClick={onSignInClick}>
          <Button
            className={styles.signIn}
            data-testid="sign-in-button"
            onClick={() => {
              track('Click nav Sign In', {});
              onSignInClick?.();
            }}
          >
            Sign in
          </Button>
        </Link>
      )}
      <Link href={registerUrl} onClick={onRegisterClick}>
        <Button
          className={styles.register}
          data-testid="register-button"
          onClick={() => {
            track('Click nav Register', {});
            onRegisterClick?.();
          }}
        >
          <div className={styles.registerText}>
            Join us <SurgeryOnboarding />
          </div>
        </Button>
      </Link>
    </div>
  );
};
